<template>
	<div id="main-container">
		<b-overlay
			id="overlay-coi-list-card"
			:show="queryInProgress"
			variant="light"
			opacity="0.5"
			blur="2px"
			rounded="lg"
		><!-- overlay -->
			<b-card class=" mx-3 mt-1">
				<div class="row" id="coi-pagination">
					<div class="col-md-2">
						<div class="d-flex justify-content-start pt-3">
							<h3 pt-3>Replacements freigeben</h3>
						</div>
					</div>
					<div class="col-md-10">
						<div class="d-flex flex-row justify-content-end">
							<div class="d-flex flex-row-reverse">
								<div class="py-2">
									<b-form-select
										id="per-page-select"
										v-model="perPage"
										:options="pageOptions"
										size="md"
									></b-form-select>
								</div>
								<div class="p-2">
									<b-pagination
										id="table-pagination-replacement-orders"
										class="float-right"
										v-if="replacementOrders"
										v-model="currentPage"
										:total-rows="replacementOrders.length"
										:per-page="perPage"
										aria-controls="table-replacement-orders"
									></b-pagination>
								</div>
                                <div class="p-2">
                                    <b-button @click="createConfirmedReplacementOrder" :disabled="!marketOrderId"><span class="icon icon-plus"/></b-button>
                                </div>
                                <div class="p-2">
                                    <b-input placeholder="Market-Order-ID" v-model="marketOrderId"></b-input>
                                </div>
							</div>
						</div>
					</div>
				</div>
				<b-table
                    id="table-replacement-orders"
					class="mt-3"
					:items="replacementOrders"
					:fields="fields"
					:per-page="perPage"
					:current-page="currentPage"
					small
					hover
                ></b-table>
			</b-card>
		</b-overlay>
	</div>
</template>
<script>
export default {
	components: { },
	data() {
		return {
			queryInProgress: false
		  , replacementOrders: []
          , marketOrderId: null
		  , perPage: 1000
		  , currentPage: 1
		  , pageOptions: [25, 100, 250, 1000]
		  , tHeight: this.window.innerHeight - 75
          ,fields: [
			  { key: "marketOrderId", label: "Market-Order-ID", sortable: true }
			, { key: "created_at"   , label: "erstellt Am"    , sortable: true }
			, { key: "updated_at"   , label: "geupdated Am"   , sortable: true }
		  ]
		};
	},methods:{
        fetchData() {
            this.queryInProgress = true;
            return new Promise( (resolve, reject) => {
                axios.get("confirmedreplacementorder/all")
                .then( response => {
                    this.replacementOrders = response.data;
                    this.queryInProgress = false;
                    resolve();
                }).catch( error => {
                    alert("konnte replacement-orders nicht vom Server holen.");
                    this.queryInProgress = false;
                    console.error(error);
                    reject(error);
                });
            });
        },
        createConfirmedReplacementOrder() {
            console.log("called createConfirmedReplacementOrder");
            if(!this.marketOrderId) {

            }

            if(this.replacementOrders.find( o => o.marketOrderId == this.marketOrderId )) {
                alert(`Eine Replacement-Order mit der Market-Order-ID: ${this.marketOrderId} existiert bereits.`);
                return;
            }
            this.queryInProgress = true;
            axios.post('confirmedreplacementorder/create', { marketOrderId: this.marketOrderId } ).then( response => {
                this.marketOrderId = null;
                this.fetchData();
            }).catch( error => {
                alert("konnte replacement-order nicht erzeugen.");
                this.queryInProgress = false;
            });
        }
	},
    created() { this.fetchData() } 
};
</script>
